/**
 * Hand-off store for files dropped anywhere in the shell (`DropOverlay`) or
 * chosen from the Lägg till sheet before the receiving page has mounted.
 * The shell stashes, navigates to /lagg-till/kvitto, and that page takes.
 * Module-level on purpose: files never touch Dexie until the inbox service
 * (workstream F) accepts them.
 */
import { useSyncExternalStore } from 'react';

let pending: File[] = [];
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function stashFiles(files: File[]): void {
  if (!files.length) return;
  pending = [...pending, ...files];
  emit();
}

/** Remove and return every stashed file. */
export function takeFiles(): File[] {
  const out = pending;
  pending = [];
  if (out.length) emit();
  return out;
}

export function peekFiles(): File[] {
  return pending;
}

export function usePendingFileCount(): number {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => pending.length,
    () => 0,
  );
}
